module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s12-5b68c66c9380d136527f19b4b3582b18.jpg";